import React, { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function AdminQuotesTable() {
  const [quotes, setQuotes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function fetchQuotes() {
      const { data, error } = await supabase
        .from("artist_quotes")
        .select("id, artist, medium, average_value, price_per_m2, notes, updated_at")
        .order("updated_at", { ascending: false });

      if (!error) setQuotes(data);
      setLoading(false);
    }
    fetchQuotes();
  }, []);

  if (loading) return <p>Chargement des cotes...</p>;

  return (
    <div className="overflow-x-auto">
      <h2 className="text-xl font-semibold mb-4">📋 Cotes enregistrées</h2>
      <table className="w-full border">
        <thead className="bg-gray-100">
          <tr>
            <th className="p-2 text-left">Artiste</th>
            <th className="p-2 text-left">Médium</th>
            <th className="p-2 text-left">Valeur moyenne (€)</th>
            <th className="p-2 text-left">€/m²</th>
            <th className="p-2 text-left">Notes</th>
            <th className="p-2 text-left">Mise à jour</th>
          </tr>
        </thead>
        <tbody>
          {quotes.map((q) => (
            <tr key={q.id} className="border-t">
              <td className="p-2">{q.artist}</td>
              <td className="p-2">{q.medium}</td>
              <td className="p-2">{q.average_value} €</td>
              <td className="p-2">{q.price_per_m2 || "-"}</td>
              <td className="p-2 text-sm text-gray-700">{q.notes || ""}</td>
              <td className="p-2 text-xs text-gray-500">{new Date(q.updated_at).toLocaleDateString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
